import styled from "styled-components";
import { FriendListBg } from "@assets";

export const Loader = styled.div`
  width: 100%;
  height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RootContainer = styled.div`
  padding: 24px 16px;
`;

export const Top = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img.attrs({
  alt: "icon",
})`
  width: 62px;
  height: 62px;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 13px;
`;

export const Title = styled.div`
  text-align: center;
  color: #000;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-left: 3px;
  padding-right: 3px;
`;

export const PlayerListContainer = styled.div`
  width: 94%;
  background: #E1F0FF;
  border-radius: 10px;
  margin-top: 16px;
  padding: 8px 8px 16px 8px;
`;

export const PlayerBox = styled.div`
  border-bottom: 1px solid #66BFE9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0.5;
`;

export const NoCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex: 0.3;
  width: 100%;
  height: 55px;
`;

export const NoText = styled.div`
  color: #000;
  font-weight: 400;
  font-size: 16px;
`;

export const NameCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  flex: 1.7;
  width: 100%;
  height: 55px;
`;

export const AmountCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 55px;
`;

export const NameText = styled.div`
  color: #000;
  font-size: 16px;
  font-weight: 400;
  padding-bottom: 3px;
`;

export const PhoneText = styled.div`
  color: #535353;
  font-size: 14px;
  font-weight: 400;
`;

export const AmountText = styled.div`
  color: #0095DA;
  font-size: 16px;
  font-weight: 500;
`;

export const TitleWrapper = styled.div`
  background-image: url(${FriendListBg});
  background-repeat: no-repeat;
  background-position: center; /* Center the background image horizontally and vertically */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
  padding-top: 3px;
  padding-bottom: 3px;
`;
